import React, {Component} from 'react';

import '../assets/scss/slider.scss';
import marked from "./markdown";

import ImageSlider from "./imageSlider.class";
import ImageTiles from "./imageTiles.class";

import {go, goTo} from './sliderFunctions';

// import {ReactComponent as Left} from '../assets/img/svg/left.svg';
// import {ReactComponent as Right} from '../assets/img/svg/right.svg';

let timer = null;
let subTimer = null;

class Slider extends Component {

    constructor(props) {
        super(props);

        this.state = {
            headline: '',
            slides: [],
            imagePosition: '',
            current: 0
        };
    }


    render() {
        let left = '-100%';

        if (this.state.slides.length <= 1) {
            left = 0;
        }

        return (
            <div className={'sliderBoxElm'} id={this.props.id}>

                <div className={'headlines'}>
                    <h2>
                        {this.state.headline['Ueberschrift']}
                    </h2>
                </div>

                <div className="horizontalShadow" />

                <div className={'sliderBackgroundBox'}>
                    <div className={'sliderOuter'}>
                        {(this.state.slides.length > 1) &&
                        <>
                            <div className={'prevSlide icon-prev'} onClick={() => go('prev', this.props.id, timer, subTimer, this)} />
                            <div className={'nextSlide icon-next'} onClick={() => go('next', this.props.id, timer, subTimer, this)} />
                        </>
                        }


                        <div className={'slideBox'}>

                            <div className={'slides'} style={{left:left}}>
                                {
                                    (this.state.slides.length > 0) &&
                                    this.state.slides.map((slide, key) => {

                                        let className = '';


                                        if (!!this.state.imagePosition) {
                                            className = (slide['Bildposition'] === 'Links') ? ' left' : ' right';
                                        } else {
                                            if (key % 2 === 0) {
                                                className = ' left';
                                            }
                                        }


                                        if (key === 0) {
                                            className += ' current';
                                        } else if ( key === this.state.slides.length-1) {
                                            className += ' prev';
                                        } else if (key !== 0) {
                                            className += ' next';
                                        }

                                        let images = !!slide['Bild'] ? slide['Bild'].split(',') : [undefined];

                                        return (
                                            <div key={'slide_' + key} className={'slide' + className}>
                                                <div className={'textBox'}>
                                                    <div className="textBoxInner">
                                                        {!!slide['Datum'] &&
                                                        <strong>{slide['Datum']}</strong>
                                                        }
                                                        <h3 className="headline">
                                                            {slide['Ueberschrift']}
                                                        </h3>

                                                        <p className="text" dangerouslySetInnerHTML={{__html: marked(slide['Text'])}} />

                                                      {(slide['Button'] && slide['Link']) &&
                                                        <a className={'button'} href={slide['Link']} target={slide['Linktarget'] || '_self'}>
                                                          {slide['Button']}
                                                        </a>
                                                      }
                                                    </div>
                                                </div>

                                                <div className={'imageBox'}>
                                                    {(!!images && images.length && slide['Bildtyp'] === 'Kacheln') ?
                                                        <ImageTiles images={images} id={this.props.id} tab={slide['Typ']} forceLoad={this.state.current===slide['Typ']} />
                                                        :
                                                        <ImageSlider images={images} id={this.props.id} tab={slide['Typ']} forceLoad={this.state.current===slide['Typ']} />
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {(this.state.slides.length > 1) &&
                <div className={'bubbleBox'}>
                    {
                        (this.state.slides.length > 1) &&
                        this.state.slides.map((slide, key) => {
                                return <div key={'bubble_' + key} className={'bubble' + (this.state.current === key ? ' current' : '')} onClick={() => goTo(key, this.props.id, timer, subTimer, this)} />;
                            }
                        )
                    }
                </div>
                }

              <div className="horizontalLine" />
            </div>
        );
    }

    componentDidMount() {
        this.setState({
            slides: this.props.data ? this.props.data.filter(d => d['Typ'] !== 'Ueberschrift' && d['Typ'] !== 'Bildposition') : [],
            headline: this.props.data ? this.props.data.filter(d => d['Typ'] === 'Ueberschrift')[0]: ''
        });
    }
}

export default Slider;
